// @README requires $language and $fallback params
const i18nvalueSubqueryFactory = <T>(field: string) =>
  [
    `coalesce(${field}[_key == $language][0].value, ${field}[_key == $fallback][0].value, null)`,
    {} as unknown as T | null
  ] as [string, T | null];

export default i18nvalueSubqueryFactory;
